import { GetServerSideProps } from 'next';

// utils
import { fetchNavHTML } from 'libs/server/nav';
import { fetchUser } from 'libs/server/users';
import { badRequest } from 'libs/universal/errors';
import { parseStaticContent } from 'libs/contentful/staticContent/mappers';

// Components
import { fetchStaticContent } from 'libs/contentful/staticContent/api';
import MobileStaticContentPage from 'components/StaticContent/MobileStaticContentPage';
import logger from '@zola-helpers/server/dist/es/logger';

const validSlugs: { [key: string]: string } = {
  accessibility: 'accessibility',
  'honeymoon-terms-and-conditions': 'honeymoon-terms-and-conditions',
  pricematch: 'price-matching',
  privacy: 'privacy',
  'stripe-terms': 'stripe-terms',
  terms: 'terms',
  shipping: 'shipping',
  'wedding-registry-completion-discount': 'wedding-registry-completion-discount',
  'price-matching': 'price-matching-baby',
  returns: 'returns',
};

export const getServerSideProps: GetServerSideProps = async ({ req, params }) => {
  const slugParam = params?.staticContentSlug;

  if (!slugParam || Array.isArray(params?.staticContentSlug)) {
    throw badRequest('Missing or invalid slug');
  }

  const slug = (slugParam as string).toLowerCase();

  if (!validSlugs[slug]) {
    logger.error(`Static content ${slug} not allowed`);
    return { notFound: true };
  }

  const [navHTML, userCtx] = await Promise.all([fetchNavHTML(req), fetchUser(req)]);

  const staticContent = await fetchStaticContent(validSlugs[slug]);
  if (!staticContent) {
    logger.error(`Static content ${slug} not found`);
    return { notFound: true };
  }
  return {
    props: JSON.parse(
      JSON.stringify({
        navHTML,
        userCtx,
        staticContent: parseStaticContent(staticContent),
      })
    ),
  };
};

export default MobileStaticContentPage;
